<template>
  <div class="hasbgpic hasHeader" style="margin-top: 40px">
    <div class="wjx-form" style="max-width: 800px; margin: 0 auto; padding: 20px;">
      <div class="vote-header">
        <div id="toptitle">
          <span class="htitle"><div>食育小记者申请</div></span>
        </div>
      </div>
      <el-steps :active="step" finish-status="success" align-center style="margin-bottom: 30px;">
        <el-step title="验证邀请码"></el-step>
        <el-step title="填写申请表"></el-step>
        <el-step title="提交成功"></el-step>
      </el-steps>
      <div v-if="step === 0">
        <el-card>
          <el-form :model="inviteForm" label-width="100px">
            <el-form-item label="邀请码">
              <el-input v-model="inviteForm.code" placeholder="请输入 6 位邀请码" maxlength="6" style="width: 200px;"></el-input>
              <el-button type="primary" @click="validateCode" :loading="validating" style="margin-left: 10px;">验证</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <div v-if="step === 1">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" size="large">
          <el-divider content-position="left">学校信息</el-divider>
          <el-form-item label="学校名称">
            <el-input v-model="form.schoolName" disabled></el-input>
          </el-form-item>
          <el-divider content-position="left">学生信息</el-divider>
          <el-form-item label="学生姓名" prop="studentName">
            <el-input v-model="form.studentName" placeholder="请输入学生姓名"></el-input>
          </el-form-item>
          <el-form-item label="学生性别" prop="studentGender">
            <el-radio-group v-model="form.studentGender">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="学生年龄" prop="studentAge">
            <el-input-number v-model="form.studentAge" :min="6" :max="18" style="width: 100%"></el-input-number>
          </el-form-item>
          <el-form-item label="班级" prop="className">
            <el-input v-model="form.className" placeholder="如：三年级二班"></el-input>
          </el-form-item>
          <el-divider content-position="left">家长信息</el-divider>
          <el-form-item label="家长联系人" prop="parentContactName">
            <el-input v-model="form.parentContactName" placeholder="请输入家长姓名"></el-input>
          </el-form-item>
          <el-form-item label="家长职务" prop="parentPosition">
            <el-input v-model="form.parentPosition" placeholder="请输入职务"></el-input>
          </el-form-item>
          <el-form-item label="家长手机号" prop="parentPhone">
            <el-input v-model="form.parentPhone" placeholder="请输入手机号" maxlength="11"></el-input>
          </el-form-item>
          <el-divider content-position="left">其他信息</el-divider>
          <el-form-item label="自我介绍" prop="selfIntroduction">
            <el-input v-model="form.selfIntroduction" type="textarea" :rows="3" placeholder="200 字以内 必填" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="班主任推荐" prop="teacherRecommendation">
            <el-input v-model="form.teacherRecommendation" type="textarea" :rows="3" placeholder="100 字以内 必填" maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-divider content-position="left">学校意见</el-divider>
          <el-form-item label="上传图片" prop="schoolOpinionImages">
            <el-upload action="/prod-api/admin/system/index/fileUpload" list-type="picture-card" :on-success="handleImageSuccess" :before-upload="beforeImageUpload" :file-list="imageList">
              <el-icon><Plus /></el-icon>
            </el-upload>
            <div style="color: #999; font-size: 12px;">仅支持 jpg/png 格式，需包含学校盖章</div>
          </el-form-item>
          <el-form-item>
            <el-button @click="step = 0">上一步</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitting">提交申请</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="step === 2">
        <el-result icon="success" title="申请提交成功" sub-title="请等待管理员审核">
          <template #extra>
            <el-button type="primary" @click="resetForm">再次申请</el-button>
          </template>
        </el-result>
      </div>
    </div>
  </div>
</template>

<script>
import { Plus } from "@element-plus/icons-vue"
import studentApplyApi from "@/api/studentApply"
import { ElMessage } from "element-plus"

export default {
  name: "StudentApply",
  components: { Plus },
  data() {
    return {
      step: 0,
      inviteForm: { code: "" },
      form: {
        inviteCode: "", schoolApplyId: "", schoolName: "", schoolType: "",
        studentName: "", studentGender: "男", studentAge: 10, className: "",
        parentContactName: "", parentPosition: "", parentPhone: "",
        selfIntroduction: "", teacherRecommendation: "", schoolOpinionImages: ""
      },
      rules: {
        studentName: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
        studentAge: [{ required: true, message: "请输入学生年龄", trigger: "blur" }],
        className: [{ required: true, message: "请输入班级", trigger: "blur" }],
        parentContactName: [{ required: true, message: "请输入家长联系人", trigger: "blur" }],
        parentPhone: [{ required: true, message: "请输入家长手机号", trigger: "blur" }],
        selfIntroduction: [{ required: true, message: "请输入自我介绍", trigger: "blur" }],
        teacherRecommendation: [{ required: true, message: "请输入班主任推荐", trigger: "blur" }],
        schoolOpinionImages: [{ required: true, message: "请上传学校意见图片", trigger: "change" }]
      },
      imageList: [],
      validating: false,
      submitting: false
    }
  },
  methods: {
    async validateCode() {
      if (!this.inviteForm.code) { ElMessage.warning("请输入邀请码"); return }
      this.validating = true
      try {
        const res = await studentApplyApi.validateInviteCode(this.inviteForm.code)
        if (res.data) {
          const schoolRes = await studentApplyApi.getSchoolInfo(this.inviteForm.code)
          this.form.inviteCode = this.inviteForm.code
          this.form.schoolApplyId = schoolRes.data.schoolApplyId
          this.form.schoolName = schoolRes.data.schoolName
          this.form.schoolType = schoolRes.data.schoolType || ""
          this.step = 1
          ElMessage.success("邀请码验证成功")
        } else { ElMessage.error("邀请码无效") }
      } catch (e) { ElMessage.error("邀请码验证失败") }
      finally { this.validating = false }
    },
    handleImageSuccess(response, file, fileList) {
      this.imageList = fileList
      this.form.schoolOpinionImages = fileList.map(f => f.response.data).join(",")
    },
    beforeImageUpload(file) {
      const isImage = file.type === "image/jpeg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) ElMessage.error("只能上传 JPG/PNG 格式!")
      if (!isLt5M) ElMessage.error("图片大小不能超过 5MB!")
      return isImage && isLt5M
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          await studentApplyApi.submitApply(this.form)
          this.step = 2
        } catch (e) { ElMessage.error("提交失败，请稍后重试") }
        finally { this.submitting = false }
      })
    },
    resetForm() {
      this.step = 0
      this.inviteForm.code = ""
      this.form = { inviteCode: "", schoolApplyId: "", schoolName: "", schoolType: "", studentName: "", studentGender: "男", studentAge: 10, className: "", parentContactName: "", parentPosition: "", parentPhone: "", selfIntroduction: "", teacherRecommendation: "", schoolOpinionImages: "" }
      this.imageList = []
    }
  }
}
</script>

<style scoped>@import "../assets/fs/newForm.css";</style>
